export function formatPostcode(value) {
    const digits = String(value || '').replace(/\D/g, '');

    return digits.length === 8 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
}

export function formatShippingPostcode(value) {
    const digits = String(value).replace(/\D/g, '').slice(0, 8);

    if (digits.length > 5) {
        return digits.slice(0, 5) + '-' + digits.slice(5);
    }

    return digits;
}

export function escapeHtml(value) {
    return $('<div>').text(value == null ? '' : value).html();
}

export function plainText(value) {
    return $.trim($('<div>').html(value == null ? '' : String(value)).text());
}

export function formatDelivery(value) {
    const text = plainText(value).replace(/^-\s*/, '');

    return /^\d+$/.test(text) ? '' : text;
}

export function snapQuantity($quantity, quantity) {
    const step = Math.max(1, parseInt($quantity.attr('data-step'), 10) || 1);
    const wanted = parseInt(quantity, 10) || step;

    return Math.max(step, Math.ceil(wanted / step) * step);
}

export function createDrawerEventBinder(drawerSelector) {
    return function(eventName, selector, handler) {
        const scopedSelector = drawerSelector + ' ' + selector;
        const namespacedEvent = eventName + '.cartDrawerActions';

        $(document).off(namespacedEvent, scopedSelector).on(namespacedEvent, scopedSelector, handler);
    };
}
